import { AxiosError, AxiosResponse } from "axios";
import { useFormik } from "formik";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "src/contexts/AuthContext";
import { Button, MainContainer, TextField } from "../../components";
import {
  IntegratorCallbackResponse,
  IntegratorCallbackResponseError,
  integratorCallback,
} from "../../hooks/integrator";
import { useQueryParams } from "../../hooks/queryParams";
import {
  ButtonContainer,
  Container,
  Form,
  FormRow,
  Heading,
  Image,
  Label,
} from "./styles";

interface AuthData {
  user: string;
  password: string;
}

const ProviderSignIn: React.FC = () => {
  const { authenticate } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const params = useQueryParams();

  const provider = {
    logo: params.get("logo"),
    name: params.get("name"),
  };

  const formik = useFormik<AuthData>({
    initialValues: {
      user: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};

      if (!values.user) {
        errors = {
          ...errors,
          user: "Preencha seu email",
        };
      }

      if (!values.password) {
        errors = {
          ...errors,
          password: "Preencha sua senha",
        };
      }

      return errors;
    },
    onSubmit: (values) => {
      integratorCallback("", "", values.user, values.password)
        .then((response: AxiosResponse<IntegratorCallbackResponse>) => {
          if (response.data.userId) {
            localStorage.setItem("userId", response.data.userId);
            localStorage.setItem("providerId", response.data.providerId);
            localStorage.setItem("state", response.data.state);

            window.location.href = "/terms";
          }
        })
        .catch((error: AxiosError<IntegratorCallbackResponseError>) => {
          const errorId = error.response?.data.errorId ?? "";

          if (error.response?.status === 401) {
            window.location.href = `/error?error_code=104&logo=${provider.logo}&name=${provider.name}&error_id=${errorId}`;
            return;
          }

          window.location.href = `/error?error_code=100&error_id=${errorId}`;
        });
    },
  });

  return (
    <MainContainer>
      <Container>
        <Heading>Entre com seus dados da operadora</Heading>

        {provider.logo && (
          <Image
            src={provider.logo}
            alt={provider.name!}
            title={provider.name!}
          />
        )}

        <Form onSubmit={formik.handleSubmit}>
          <FormRow style={{ marginBottom: 20 }}>
            <Label>Usuário</Label>
            <TextField
              type="text"
              name="user"
              value={formik.values.user}
              onChange={formik.handleChange}
              hasError={!!formik.getFieldMeta("user").error}
              helperText={formik.getFieldMeta("user").error}
            />
          </FormRow>

          <FormRow>
            <Label>Senha</Label>
            <TextField
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              hasError={!!formik.getFieldMeta("password").error}
              helperText={formik.getFieldMeta("password").error}
            />
          </FormRow>

          <FormRow>
            <ButtonContainer>
              <Button type="submit">Entrar</Button>
            </ButtonContainer>
          </FormRow>
        </Form>
      </Container>
    </MainContainer>
  );
};

export default ProviderSignIn;
